import React from 'react';

import PowerMeterSVG from './power-meter.svg?react';

function FarmbotPowerMeterIcon() {
  return <PowerMeterSVG width={18} />;
}

export default FarmbotPowerMeterIcon;
